import { render, staticRenderFns } from "./ContactsMap.vue?vue&type=template&id=d0e4e508&lang=pug&"
import script from "./ContactsMap.vue?vue&type=script&lang=js&"
export * from "./ContactsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports